import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

// components
import { RightArrow } from "components/common";

// utils
import { moneyFormatter } from "utils";

const TodaysVouchers = ({ voucherData, isAll, ...props }) => {
  const navigate = useNavigate();

  const sections = [
    {
      key: "appointment",
      label: "개인레슨",
      color: "#7357C5",
      valuePercent: voucherData.appointmentSalesPercent,
      valueAmount: voucherData.appointmentSalesAmount,
    },
    {
      key: "group",
      label: "그룹수업",
      color: "#E79B37",
      valuePercent: voucherData.classSalesPercent,
      valueAmount: voucherData.classSalesAmount,
    },
    {
      key: "place",
      label: "시설이용",
      color: "#3474FA",
      valuePercent: voucherData.placeSalePercent,
      valueAmount: voucherData.placeSaleAmount,
    },
    {
      key: "option",
      label: "옵션이용",
      color: "#53BBD0",
      valuePercent: voucherData.optionSalesPercent,
      valueAmount: voucherData.optionSalesAmount,
    },
    {
      key: "package",
      label: "패키지",
      color: "#2DB38B",
      valuePercent: voucherData.packageSalePercent,
      valueAmount: voucherData.packageSaleAmount,
    },
  ];

  const renderSections = () => {
    return sections.map((section) => {
      return (
        <StatsWrapper className="bottom-padding" key={section.key}>
          <div>
            <Dot color={section.color} />
            <StatTitle>{section.label}</StatTitle>
            <Percent color={section.color}>
              &middot; {section.valuePercent ? section.valuePercent : 0}%
            </Percent>
          </div>
          <StatAmount>{moneyFormatter(section.valueAmount)}</StatAmount>
        </StatsWrapper>
      );
    });
  };

  return (
    <MainWrapper
      onClick={() =>
        isAll ? navigate("/sales/branch/voucher") : navigate("/sales/voucher")
      }
    >
      <CardTitleWrapper>
        <Title>오늘의 이용권 종류별 매출</Title>
        <RightArrow size="S" />
      </CardTitleWrapper>

      {renderSections()}
    </MainWrapper>
  );
};

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  padding: 24px 24px 26px 24px;
  border-radius: 12px;
  height: 258px;
  background-color: ${(props) => props.theme.colors.cardBackground};
`;

const CardTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const Title = styled.p`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.primaryTextColor};
`;

const StatsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  &.bottom-padding {
    padding-bottom: 12px;
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
`;

const Percent = styled.span`
  font-size: 14px;
  line-height: 20px;
  margin-left: 4px;
  color: ${(props) => props.color};
`;

const StatTitle = styled.p`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.primaryTextColor};
`;

const Dot = styled.span`
  height: 8px;
  width: 8px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  margin-right: 6px;
`;

const StatAmount = styled.p`
  font-feature-settings: "tnum" on, "lnum" on;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.primaryTextColor};
`;

TodaysVouchers.propTypes = {
  voucherData: PropTypes.object,
  onClick: PropTypes.func,
};

export default TodaysVouchers;
